import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from '@/router'
import piniaPluginPersistedState from 'pinia-plugin-persistedstate'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'

import { createI18n } from 'vue-i18n'
import enGB from '@/locales/en.json'
import deCH from '@/locales/de.json'

const i18n = createI18n({
    legacy: false, // This disables the legacy API mode
    locale: 'de-CH',
    fallbackLocale: 'en-GB',
    messages: {
        'en-GB': enGB,
        'de-CH': deCH,
    },
})

const pinia = createPinia()
pinia.use(piniaPluginPersistedState)

const vuetify = createVuetify({
    components,
    directives,
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            mdi,
        },
    },
})

let app = createApp(App)
app.use(vuetify)
app.use(i18n)
app.use(pinia)
app.use(router)
app.mount('#app')
